export default function omitByObjectUtil (object, predicate) {
  if (typeof predicate !== 'function') {
    throw new Error('Predicate must be a function')
  }

  return Object.keys(object).reduce((acc, key) => {
    if (!predicate(object[key])) {
      acc[key] = object[key]
    }
    return acc
  }, {})
}
